import React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';

export const CategoryShow = () => (
  <Show title="Category details">
    <SimpleShowLayout>
      <TextField source="name" label="Name" />
      <TextField source="description" label="Description" />
    </SimpleShowLayout>
  </Show>
);

